<div [ngClass]="classSurcharge" class="cado-modal">
    <div [ngClass]="classSurcharge" class="cado-modal-body container">
        <ng-content></ng-content>
    </div>
</div>
<div [ngClass]="classSurcharge" class="cado-modal-background"></div>
